module.exports = __webpack_public_path__ + "static/media/art58.3617bdac.jpg";